// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1a4fe20a","205":"c9f313b1","209":"dce419be","403":"639014ea","551":"b0ffe9f2","629":"3c99ad5f","808":"73d8b9de","851":"3f0086ba"}[chunkId] + ".chunk.js";
};